var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product align-center w-100 pb20" },
    [
      _c(
        "div",
        { staticClass: "product__icons" },
        [
          _c(
            "AddToWishlist",
            {
              attrs: { categoryProps: _vm.categoryProps, product: _vm.product }
            },
            [
              _c(
                "div",
                {
                  staticClass: "product__icon",
                  class: { "product__icon--active": _vm.isOnWishlist },
                  attrs: {
                    title: _vm.isOnWishlist
                      ? _vm.$t("Remove")
                      : _vm.$t("Add to favorite")
                  }
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(_vm._s(_vm.favoriteIcon))
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.showCompare
            ? _c("AddToCompare", { attrs: { product: _vm.product } }, [
                _c(
                  "div",
                  {
                    staticClass: "product__icon",
                    class: { "product__icon--active": _vm.isOnCompare },
                    attrs: {
                      title: _vm.isOnCompare
                        ? _vm.$t("Remove from compare")
                        : _vm.$t("Add to compare")
                    }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("compare")
                    ])
                  ]
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "block no-underline product-link",
          attrs: { to: _vm.productLink, "data-testid": "productLink" }
        },
        [
          _c(
            "div",
            {
              staticClass: "product-cover",
              class: [
                { sale: _vm.labelsActive && _vm.isOnSale },
                { new: _vm.labelsActive && _vm.isNew }
              ]
            },
            [
              _vm.isBadge
                ? _c("Badge", {
                    attrs: {
                      categoryProps: _vm.categoryProps,
                      product: _vm.product
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "product-image relative",
                  class: [
                    { sale: _vm.labelsActive && _vm.isOnSale },
                    { new: _vm.labelsActive && _vm.isNew }
                  ]
                },
                [
                  _c("product-image-cloudfront", {
                    staticClass: "product-image__content",
                    attrs: {
                      "thumbnail-path": _vm.product.thumbnail_path,
                      "thumbnail-size": "175",
                      alt: _vm._f("htmlDecode")(_vm.product.name),
                      "data-testid": "productImage"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.onlyImage && _vm.isH4
            ? _c("h4", { staticClass: "mb10 cl-accent mt0 product-title" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm._f("htmlDecode")(_vm.product.name))
                ),
                _c("br"),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("htmlDecode")(_vm.product.short_name)) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.onlyImage && !_vm.isH4
            ? _c("h3", { staticClass: "mb10 cl-accent mt0 product-title" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm._f("htmlDecode")(_vm.product.name))
                ),
                _c("br"),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("htmlDecode")(_vm.product.short_name)) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("product-available", {
            attrs: { product: _vm.product, categoryProps: _vm.categoryProps }
          }),
          _vm._v(" "),
          _c("div", [
            _vm.product.special_price &&
            parseFloat(_vm.product.special_price) > 0 &&
            !_vm.onlyImage
              ? _c(
                  "div",
                  {
                    staticClass: "price-special cl-accent",
                    class: _vm.priceSpecialColor
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("price")(
                            _vm.product.price_incl_tax,
                            _vm.storeView
                          )
                        ) +
                        "\n        \n        "
                    ),
                    _vm.product.special_price_incl_tax
                      ? _c("span", { staticClass: "price-original" }, [
                          _c("br"),
                          _vm._v(
                            "\n\n          " +
                              _vm._s(
                                _vm._f("price")(
                                  _vm.product.special_price_incl_tax || 0,
                                  _vm.storeView
                                )
                              ) +
                              "\n\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cart-icon-container" },
                      [_c("add-to-cart", { attrs: { product: _vm.product } })],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.product.special_price &&
            parseFloat(_vm.product.original_price_incl_tax) > 0 &&
            !_vm.onlyImage
              ? _c(
                  "span",
                  { staticClass: "price-original mr0 lh30 cl-secondary" },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("price")(
                            _vm.product.original_price_incl_tax,
                            _vm.storeView
                          )
                        ) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.product.special_price &&
            parseFloat(_vm.product.price_incl_tax) > 0 &&
            !_vm.onlyImage
              ? _c(
                  "div",
                  {
                    staticClass: "lh30 cl-secondary cart-icon-category",
                    class: _vm.priceColor
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("price")(
                            _vm.product.final_price,
                            _vm.storeView
                          )
                        ) +
                        "\n\n        "
                    ),
                    _c(
                      "div",
                      { staticClass: "cart-icon-container" },
                      [_c("add-to-cart", { attrs: { product: _vm.product } })],
                      1
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }